import React, { MouseEvent } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Image,
  Accordion,
  Icon,
} from "semantic-ui-react";
import {
  LoginInfo,
} from "../Utils/Login";
import { useAuth } from "react-oidc-context";

type LoginProps = {
  setLoginInfo: (input: LoginInfo) => void;
};

export default function LoginDialog(props: LoginProps) {
  const [errorMessage, setErrorMessage] = React.useState("");
  const auth = useAuth();
  const location = useLocation();
  const query = React.useMemo(() => new URLSearchParams(location.search), [location.search]);

  // Redirect to www subdomain if origin is https://lambdaphi.org/
  React.useEffect(() => {
    if (window.location.origin === "https://lambdaphi.org") {
      window.location.href = "https://www.lambdaphi.org" + window.location.pathname + window.location.search;
    }
  }, []);

  // Check for error parameters in URL
  React.useEffect(() => {
    const error = query.get("error");
    if (error === "auth_failed") {
      setErrorMessage("Authentication failed. Please try again.");
    } else if (error === "user_conversion_failed") {
      setErrorMessage("User information could not be retrieved. Please contact support.");
    }
  }, [query]);

  async function handleLogin(event: MouseEvent) {
    event.preventDefault();

    try {
      // Get destination parameter for redirect after login
      const destParam = query.get("dest");

      // Create state object to pass destination information
      const state = destParam ? { dest: destParam } : {};

      // Sign in using OIDC with state parameter
      await auth.signinRedirect({
        redirect_uri: window.location.origin + "/callback",
        state: state
      });
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage("An error occurred during login. Please try again.");
    }
  }

  let messageElement: JSX.Element = <></>;
  if (errorMessage) {
    messageElement = (
      <Message negative>
        <div>{errorMessage}</div>
      </Message>
    );
  }



  return (
    <Grid centered stackable>
      <Grid.Column width={10}>
        <Image src="/images/lpcrest.png" floated="left" />
        <h1>Welcome</h1>
        <p>
          Welcome! This is a private website for the members of the alumni
          corporation of the Lambda Phi Chapter of the Alpha Delta Phi
          Society.
        </p>
      </Grid.Column>
      <Grid.Column width={6}>
        <Header as="h2" textAlign="center">
          Login
        </Header>
        {messageElement}
        <Segment>
          <Form size="large">
            <Button primary fluid size="large" onClick={handleLogin}>
              Sign in
            </Button>
          </Form>
        </Segment>
        <Message>
          <LoginHelp />
        </Message>
      </Grid.Column>
    </Grid>
  );
}

export function LoginHelp() {
  const [active, setActive] = React.useState(false);

  function handleClick() {
    setActive(!active);
  }

  return (
    <Accordion>
      <Accordion.Title onClick={handleClick}>
        <Icon name='dropdown' rotated={active ? 'clockwise' : undefined} /> Need help?
      </Accordion.Title>
      <Accordion.Content active={active}>
        <p>
          If you've forgotten your password (or never had one in the first
          place) but you're on our e-mail mailing lists, click on the "Sign in" button above, and then click on "Forgot your password?".{" "}
          <b>Use your email address as the "username" in the form.</b>
        </p>
        <p>
          If this doesn't work or if we don't have your email address, write to{" "}
          <strong>help (at) lambdaphi.org</strong> with your name, email
          address, and pledge class name and we'll set you up.
        </p>
      </Accordion.Content>
    </Accordion >
  );
}


